export const fake =[
    {
        id: 1,
        name: 'Jane Cooper',
        followed: true
    },
    {
        id: 2,
        name: 'Jane Cooper',
        followed: true
    },
    {
        id: 3,
        name: 'Jane Cooper',
        followed: true
    },
    {
        id: 4,
        name: 'Jane Cooper',
        followed: true
    },
    {
        id: 5,
        name: 'Jane Cooper',
        followed: true
    },
    {
        id: 6,
        name: 'Jane Cooper',
        followed: true
    },
    {
        id: 7,
        name: 'Jane Cooper',
        followed: true
    },
    {
        id: 8,
        name: 'Jane Cooper',
        followed: true
    },
    {
        id: 9,
        name: 'Jane Cooper',
        followed: true
    },
    // {
    //     id: 10,
    //     name: 'Jane Cooper',
    //     followed: true
    // },
    // {
    //     id: 11,
    //     name: 'Jane Cooper',
    //     followed: true
    // },
    // {
    //     id: 12,
    //     name: 'Jane Cooper',
    //     followed: true
    // },
    // {
    //     id: 13,
    //     name: 'Jane Cooper',
    //     followed: true
    // },
    // {
    //     id: 14,
    //     name: 'Jane Cooper',
    //     followed: true
    // },
    // {
    //     id: 15,
    //     name: 'Jane Cooper',
    //     followed: true
    // },
]